import { AsyncPipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';

import { BreakpointService } from '@ecm/consumer';
import { EnvUtils } from '@ecm/dispatcher';
import { EcmMaterialModule } from '@ecm/material';
import { PortfolioFlagsService } from '@ecm/portfolio';
import { EcmRouterModule, ExtendedLinkService, Link, LinkService, TrackingData } from '@ecm/router';
import { TrackableView } from '@ecm/tracker';

import { UniverseEnum } from '../../../business/api/dashboard/universeEnum';
import { ContractV7Offer } from '../../../business/api/dashboardV7/contract/contractV7Offer';
import { Option } from '../../../business/api/dashboardV7/option';
import { PushV7 } from '../../../business/api/dashboardV7/pushV7';
import { ItemHelpViewModel } from '../../../business/model/home/itemHelp.view-model';
import { ItemV7ViewModel } from '../../../business/model/home/itemV7.view-model';
import { DeviceStatus } from '../../../business/model/homelan/deviceStatus.view-model';
import { TrackingService } from '../../../services/tracking.service';
import { UrlService } from '../../../services/url.service';
import { DeviceStatusComponent } from '../../homelan/device-status/device-status';
import { FixeSubItemComponent } from '../../shared/sub-item/fixe-sub-item/fixe-sub-item.component';
import { GaugeSubItemComponent } from '../../shared/sub-item/gauge-sub-item/gauge-sub-item.component';
import { PictoSubItemComponent } from '../../shared/sub-item/picto-sub-item/picto-sub-item.component';

@Component({
    selector: 'item',
    templateUrl: 'item.html',
    styleUrls: ['item.css'],
    standalone: true,
    imports: [
        NgTemplateOutlet,
        NgClass,
        DeviceStatusComponent,
        FixeSubItemComponent,
        EcmMaterialModule,
        PictoSubItemComponent,
        GaugeSubItemComponent,
        AsyncPipe,
        EcmRouterModule,
        TranslateModule,
    ],
})
export class ItemComponent implements OnInit, TrackableView {
    @Input()
    public viewModel: ItemV7ViewModel;

    @Input()
    public universe: UniverseEnum;

    @Input()
    public first: boolean;

    @Input()
    public changeMobile: PushV7;

    @Input()
    public sectionHome?: string;

    @Input()
    public multiSim?: ItemV7ViewModel[];

    @Input()
    public last?: boolean;

    @Input()
    public help?: ItemHelpViewModel;

    @Input()
    public optionsTv?: Option[];

    @Input()
    public optionsMobile?: Option[];

    @Input()
    public isMobile: boolean;

    @Input()
    public internetStatus?: DeviceStatus;

    @Input()
    public wifiStatus?: DeviceStatus;

    @Input()
    public voipStatus?: DeviceStatus;

    @Input()
    public tvStatus?: DeviceStatus;

    @Input()
    public offer!: ContractV7Offer;

    @Output() public itemActionEvent: EventEmitter<DeviceStatus> = new EventEmitter<DeviceStatus>();

    public zid: string;
    public isEclair: boolean;

    private readonly extendedLinkService = inject(ExtendedLinkService);
    private readonly _breakpointService: BreakpointService = inject(BreakpointService);
    private readonly linkService: LinkService = inject(LinkService);
    private readonly portfolioFlagsService: PortfolioFlagsService = inject(PortfolioFlagsService);
    private readonly trackingService: TrackingService = inject(TrackingService);
    private readonly urlService: UrlService = inject(UrlService);

    public isMobileWidth = toSignal(this._breakpointService.isMobileWidth());

    public ngOnInit() {
        this.isEclair = EnvUtils.isEclair();

        this.onAfterViewLoaded();
    }

    public onAfterViewLoaded(): void {
        this.trackView();
    }

    public readonly isSoshBrand = this.portfolioFlagsService.isSosh;

    public openLink(link: Link, tracking?: TrackingData, cid?: string, e?: Event) {
        if (link != null) {
            if (this.changeMobile) {
                this.linkService.openLink(
                    link,
                    tracking,
                    this.changeMobile.button.params,
                    this.changeMobile.button.navigationExtras,
                );
            } else {
                this.linkService.openLink(link, tracking);
            }
        }

        e.preventDefault();
    }

    public trackView() {
        if (this.changeMobile) {
            this.zid = this.trackingService.getTrackNamePerType(this.changeMobile, this.isMobile, this.isSoshBrand());
        }
    }

    public isDisabledEclairLink(item: any) {
        if (item?.link) {
            return this.urlService.isDisabledEclairLink(item?.link);
        }
        return false;
    }

    public formatContent(content: string | string[]): string | string[] {
        if (!Array.isArray(content)) {
            return content.replace('\n', '<br>');
        } else return content;
    }

    public itemButtonEvent(event: DeviceStatus): void {
        this.itemActionEvent.emit(event);
    }
}
